import axios from 'axios';
import { Toast } from 'antd-mobile';

// 创建 axios 实例
const request = axios.create({
    baseURL: process.env.HUMU_BASE_URL || '', // 从环境变量读取 API 基础路径
    timeout: 10000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器
request.interceptors.request.use(
    (config) => {
        // 从 localStorage 获取 token
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error('请求错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (res.code === 401) {

            // 清空 token 和用户信息
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('hmy_user');

            Toast.show({
                icon: 'fail',
                content: '登录已过期，请重新登录',
                duration: 2000
            });

            // 延迟跳转，确保提示显示
            setTimeout(() => {
                window.location.href = '/#/login';
            }, 1000);

            return Promise.reject(new Error('未授权，请重新登录'));
        }
        // 根据实际后端返回的数据结构调整
        // 假设后端返回格式: { code: 200, data: {...}, message: 'success' }
        if (res.code === 200 || response.status === 200) {
            return response.data;
        } else {
            // 业务错误
            Toast.show({
                icon: 'fail',
                content: res.message || '请求失败',
            });
            return Promise.reject(new Error(res.message || '请求失败'));
        }
    },
    (error) => {
        console.error('响应错误:', error);

        // 处理 HTTP 错误
        if (error.response) {
            const { status, data } = error.response;
            switch (status) {
                case 401:
                    // 未授权，清除 token 并跳转到登录页
                    localStorage.removeItem('token');
                    localStorage.removeItem('userInfo');
                    Toast.show({
                        icon: 'fail',
                        content: '登录已过期，请重新登录',
                    });
                    // 延迟跳转，避免在非 React 组件中使用 navigate
                    setTimeout(() => {
                        window.location.href = '/#/login';
                    }, 1500);
                    break;
                case 403:
                    Toast.show({
                        icon: 'fail',
                        content: '没有权限访问',
                    });
                    break;
                case 429:
                    Toast.show({
                        icon: 'fail',
                        content: data.msg,
                    });
                    break;
                case 404:
                    Toast.show({
                        icon: 'fail',
                        content: '请求的资源不存在',
                    });
                    break;
                case 500:
                    Toast.show({
                        icon: 'fail',
                        content: '服务器错误',
                    });
                    break;
                default:
                    Toast.show({
                        icon: 'fail',
                        content: data?.msg || '网络错误',
                    });
            }
        } else if (error.request) {
            // 请求已发出但没有收到响应
            Toast.show({
                icon: 'fail',
                content: '网络连接失败，请检查网络',
            });
        } else {
            // 其他错误
            Toast.show({
                icon: 'fail',
                content: error.message || '请求失败',
            });
        }

        return Promise.reject(error);
    }
);

export default request;
